import { useHandleServerError } from "Infrastructure/Utilities/Forms/Hooks/useHandleServerError";
import { useCreatePartnerBalanceTransactionMutation } from "Partner/Api/Mutation/createPartnerBalanceTransactionMutation";
import {
	getPartnerCreateBalanceSchema,
	type PartnerCreateBalanceFormModel,
} from "Partner/Components/Form/Schema/partnerCreateBalanceSchema";
import Input from "Shared/Components/Form/CustomFormComponent/Input";
import { zodResolver } from "@hookform/resolvers/zod";
import { Box, Button, Grid2 } from "@mui/material";
import type { FC } from "react";
import { useForm } from "react-hook-form";

type CreateBalanceFormProps = {
	partnerId: number;
};

export const CreateBalanceForm: FC<CreateBalanceFormProps> = ({
	partnerId,
}) => {
	const form = useForm<PartnerCreateBalanceFormModel>({
		resolver: zodResolver(getPartnerCreateBalanceSchema()),
		defaultValues: {
			amount: 0,
			orderId: null,
			description: "",
		},
	});

	const { mutate: createTransaction, isPending } =
		useCreatePartnerBalanceTransactionMutation(partnerId);

	const {
		control,
		formState: { errors },
	} = form;

	const { handleServerError } = useHandleServerError(form);

	const handleSubmitCreateBalance = () => {
		handleServerError(createTransaction);
	};

	return (
		<>
			<Grid2 container spacing={2}>
				<Grid2 size={{ xs: 12, sm: 6 }}>
					<Input
						id="amount"
						name="amount"
						label={"Amount"}
						variant="outlined"
						control={control}
						errors={errors}
						fullWidth
						// disabled={isFormDisabled}
						isNumber
						isFloat
						sxLabel={{ mt: 0 }}
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 6 }}>
					<Input
						id="order-id"
						name="orderId"
						label={"Order ID"}
						variant="outlined"
						control={control}
						errors={errors}
						fullWidth
						// disabled={isFormDisabled}
						isNumber
						sxLabel={{ mt: 0 }}
					/>
				</Grid2>
				<Grid2 size={{ xs: 12 }}>
					<Input
						id="description"
						name="description"
						label={"Description"}
						variant="outlined"
						control={control}
						errors={errors}
						fullWidth
						// disabled={isFormDisabled}
						multiline
					/>
				</Grid2>
			</Grid2>
			<Box mt={2}>
				<Button onClick={handleSubmitCreateBalance} loading={isPending}>
					Add item
				</Button>
			</Box>
		</>
	);
};
